import { useMemo } from "react";

export const usePredictionRewardCurrency = (asset: string) => {
  return useMemo(() => (asset === "MATIC" ? "MATIC" : "USDT"), [asset]);
};
